/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_EyebrowInputs */

const en_landing_drift_eyebrow = /** @type {(inputs: Landing_Drift_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drift-free editing`)
};

const zh_landing_drift_eyebrow = /** @type {(inputs: Landing_Drift_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无漂移精准编辑`)
};

/**
* | output |
* | --- |
* | "Drift-free editing" |
*
* @param {Landing_Drift_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_eyebrow = /** @type {((inputs?: Landing_Drift_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_eyebrow(inputs)
	return zh_landing_drift_eyebrow(inputs)
});
export { landing_drift_eyebrow as "landing.drift.eyebrow" }